import { getStories, getStoriesDetail } from '@/calls/stories';
import router from '@/router';

const stories = {
  namespaced: true,
  state: {
    requests: 0,
    requestsDetail: 0,
    items: [],
    item: null
  },
  mutations: {
    setItem(state, item) {
      state.item = item;
    },
    setItems(state, items) {
      state.items = [...items];
    },
    increaseRequests(state, type) {
      if (type) {
        state[type] += 1;
        return;
      }

      state.requests += 1;
    },
    decreaseRequests(state, type) {
      if (type) {
        state[type] -= 1;
        return;
      }

      state.requests -= 1;
    }
  },
  actions: {
    async get({ commit }, { id, loc }) {
      commit('increaseRequests');
      try {
        const response = await getStories(id, loc);
        commit('setItems', response);
      } catch (e) {
        commit('setItems', []);
        if (router.currentRoute.name !== 'Login') {
          router.push({ name: 'PageError' });
        }
      }
      commit('decreaseRequests');
    },
    async getDetail({ commit }, { id, loc }) {
      commit('increaseRequests', 'requestsDetail');
      try {
        const response = await getStoriesDetail(id, loc);
        commit('setItem', response);
      } catch (e) {
        commit('setItem', null);
        if (router.currentRoute.name !== 'Login') {
          router.push({ name: 'PageError' });
        }
      }
      commit('decreaseRequests', 'requestsDetail');
    }
  }
};

export default stories;
